<template>
    <div>
        <modal-dialog
            id="tier-picker"
            :show.sync="shown"
        >
            <template v-slot:title>
                Auto-generate Milestones
                <base-button
                    flavor="link"
                    size="large"
                    @click.prevent="help=true"
                >
                    <open-icon glyph="question-circle-o" />
                </base-button>
            </template>

            <div class="uk-grid uk-grid-small">
                <div class="uk-width-1-2 uk-push-1-4 uk-text-center">
                    <form-radio-buttons
                        id="tier_id"
                        name="tier_id"
                        v-model="selection"
                        :options="service_levels"
                        label-field="label"
                        :editable="true"
                        :required="true"
                        :separated="true"
                    />
                </div>
            </div>

            <div class="uk-modal-footer uk-text-center">
                <base-button
                    size="large"
                    @click.prevent="shown=false"
                >
                    Cancel
                </base-button>
                <base-button
                    color="primary"
                    size="large"
                    :disabled="!has_selection"
                    @click.prevent="apply_tier"
                >
                    Auto-generate Milestones
                </base-button>
            </div>
        </modal-dialog>

        <modal-dialog
            id="tier-picker-help"
            :show.sync="help"
        >
            <template v-slot:title>
                Phase Template Definitions
            </template>

            <phase-templates
                :project-phases="help_project_phases"
                :service-levels="service_levels"
            />

            <div class="uk-modal-footer uk-text-center">
                <base-button
                    size="large"
                    @click.prevent="help=false"
                >
                    Done
                </base-button>
            </div>
        </modal-dialog>
    </div>
</template>

<script type="text/javascript">
import string_utilities from "../../../mixins/StringUtilities"

import ModalDialog from "../../../dialogs/ModalDialog/ModalDialog"
import FormRadioButtons from "../../../ui/FormRadioButtons"
import BaseButton from "../../../ui/BaseButton"
import OpenIcon from "../../../ui/OpenIcon"
import PhaseTemplates from "../../../ui/PhaseTemplates"

export default {
    mixins: [string_utilities],
    components: {
        ModalDialog,
        FormRadioButtons,
        BaseButton,
        OpenIcon,
        PhaseTemplates
    },
    watch: {
        show: "reset"
    },
    methods: {
        reset () {
            this.selection = 0
        },
        toggle_selection (tier_id) {
            if(this.selection === tier_id) this.selection = 0
            else this.selection = tier_id
        },
        apply_tier () {
            this.$store.dispatch("RECORD_ACTION", {
                entity: "phase",
                id: this.phaseId,
                action: "generate",
                data: {
                    tier: this.selection
                },
                method: "post"
            }).then(() => {
                this.shown = false
            }).catch(error => {
                this.$error(error.message)
            })
        }
    },
    computed: {
        shown: {
            get () {
                return this.show
            },
            set (show) {
                if(show !== this.show) this.$emit("update:show", show)
            }
        },
        has_selection () {
            return !!this.selection
        },
        service_levels () {
            return this.dictionary("service_level")
        },
        project_phases () {
            return this.dictionary("project_phase")
        },
        help_project_phases () {
            if(!this.help) return []
            return this.project_phases.filter(project_phase => project_phase.id === this.phaseTypeId)
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        phaseId: {
            type: Number,
            required: true
        },
        phaseTypeId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            selection: 0,
            help: false
        }
    }
    /*
    watch: {
        show: "reset",
    },
    mixins: [utilities],
    components: {
        PhaseTemplateHelp,
        OpenIcon
    },
    methods: {
        reset () {
            this.tier_picked = 0
        },
        toggle_tier (tier_id) {
            if(this.tier_picked === tier_id) this.tier_picked = 0
            else this.tier_picked = tier_id
        },
        apply_tier () {
            this.$emit("picked", this.tier_picked)
        },
    },
    computed: {
        shown: {
            get () {
                return this.show
            },
            set (show) {
                if(show !== this.show) this.$emit('update:show', show)
            }
        },
        has_tier_selection () {
            return !!this.tier_picked
        },
        service_levels () {
            return this.dictionary('service_level')
        },
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        projectPhaseId: {
            type: Number,
            default: 0,
        },
    },
    data () {
        return {
            tier_picked: 0,
            help: false,
        }
    }
    */
}
</script>
